// extracted by mini-css-extract-plugin
export default {"price":"Q7-z","priceRow":"R7-z","onSale":"S7-z","msrpLabelPrice":"T7-z","msrpLabel":"U7-z","originalPrice":"V7-z","percentOff":"W7-z"};